import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #fdfdfd;
  display: flex;
  flex-direction: column;
`;

const ContentBox = styled.main`
  flex: 1;
  max-width: 800px;
  margin: 60px auto;
  padding: 40px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  font-family: 'Open Sans', sans-serif;
  color: #1a202c;
  border-top: 5px solid #fa6582;
`;

const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 32px;
  color: #1a202c;
  margin-bottom: 20px;
`;

const DateText = styled.p`
  color: #718096;
  font-size: 14px;
  margin-bottom: 30px;
  font-weight: 600;
`;

const BodyText = styled.p`
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 20px;
  font-size: 16px;
`;

const BackLink = styled(Link)`
  display: inline-block;
  margin-top: 30px;
  color: #25aae3;
  text-decoration: none;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: color 0.3s;

  &:hover {
    color: #1c94c9;
    text-decoration: underline;
  }
`;

const Shutdown = () => {
  return (
    <PageContainer>
      <ContentBox>
        <Title>Official Shutdown: Gainsta Platform Closure</Title>
        <DateText>Effective Date: December 2022</DateText>
        <BodyText>
          Dear Gainsta Community,
        </BodyText>
        <BodyText>
          It is with a heavy heart that we announce the official sunset of all Gainsta services. Over the past few years, our platform has proudly helped thousands of users grow their presence on Instagram passively and genuinely.
        </BodyText>
        <BodyText>
          However, due to significant and persistent changes in Instagram's official API, as well as their tightened restrictions on automated social interactions, we can no longer guarantee the safety and structural integrity of the services we provide. Continuing to operate under these new constraints would pose an unacceptable risk to our users' personal and professional accounts.
        </BodyText>
        <BodyText>
          We’ve always prioritized transparency and account safety. Because we cannot maintain the high standards we promised without violating the changing platform terms, we have made the difficult decision to close our doors.
        </BodyText>
        <BodyText>
          We thank you deeply for your support, your feedback, and the trust you've placed in us over the years. We wish you the very best in your continued social media endeavors.
        </BodyText>
        <BodyText>
          <strong>- The Gainsta Team</strong>
        </BodyText>

        <BackLink to="/">← Return to Homepage</BackLink>
      </ContentBox>
    </PageContainer>
  );
};

export default Shutdown;
